/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { useLocation } from 'react-router-dom'

import { oneDpShadowCss } from '../../../../lib/styles/shadows'
import { BP_SMALL_UP, BP_SMALL_DOWN, BP_MEDIUM_DOWN } from '../../../../lib/styles/breakpoints'
import { BackButton } from '../../buttons'
import { LocationState } from '../../../../types'

const titleWrapperCss = css`
  background-color: #ffffff;

  @media (${BP_SMALL_UP}) {
    padding: 5px 36px;
  }

  @media (${BP_SMALL_DOWN}) {
    padding: 5px;
  }
`

const navContainerCss = css`
  @media (${BP_MEDIUM_DOWN}) {
    padding-bottom: 15px;
    margin-right: 5px;
  }
`
const linkContainerCss = css`
  display: inline-block;
  margin-left: -30px;

  @media (${BP_MEDIUM_DOWN}) {
    padding-top: 10px;
  }
  @media (${BP_SMALL_DOWN}) {
    margin-left: 0;
  }
`
const navLinkCss = css`
  margin-top: 4px;
`

type PageHeaderProps = {
  /** Children React Components */
  children: React.ReactNode
  /** Optional css class */
  className?: string
  /** React Components displayed next to the Back button. */
  navElement?: React.ReactNode
  /** Href property for the back button. */
  navHref?: string
  /** Text for the back button. */
  navText?: string
}

const defaultProps: Omit<PageHeaderProps, 'children'> = {
  className: undefined,
  navElement: null,
  navHref: undefined,
  navText: undefined
}

const PageHeader = ({ children, className, navElement, navHref, navText }: PageHeaderProps) => {
  const location = useLocation<LocationState>()
  const formattedHref = `${navHref}${location.state?.search || location.search}`

  return (
    <div className={className} css={[titleWrapperCss, oneDpShadowCss]}>
      {navHref && navText && (
        <div css={navContainerCss}>
          <div css={linkContainerCss}>
            <BackButton css={navLinkCss} href={formattedHref}>
              {navText}
            </BackButton>
          </div>
          {navElement}
        </div>
      )}
      {children}
    </div>
  )
}

PageHeader.defaultProps = defaultProps

export default PageHeader
